/* eslint no-multi-spaces: 0 */
global.config = global.config || {
  enableThemes: true
}

// Vue
import Vue           from 'vue'
import App           from './App'
import { EventBus }  from '@/event-bus'
import router        from '@/router'
import {store}       from '@/components/store'
import {i18n}        from '@/lang/lang'
import AsyncComputed from 'vue-async-computed'
import PubNub        from 'vue-pubnub'

// Core
import API                from '@/core/api'
import CoreComponents     from '@/core/components'
import NotificationPlugin from '@/core/components/mdNotifications/install'
import Charts             from '@/core/charts'

// Libraries
import 'bootstrap/dist/css/bootstrap.css'
import '@/assets/sass/main.scss'
import 'es6-promise/auto'

Vue.config.productionTip = false
Vue.config.warnHandler = (msg, vm, trace) => {
  if (~msg.indexOf('Error compiling template')) EventBus.$emit('warning', { msg })
  else console.warn(msg)
}

// Install
Vue.use(AsyncComputed)
Vue.use(API)
Vue.use(CoreComponents)
Vue.use(NotificationPlugin)
Vue.use(Charts)
Vue.use(PubNub, {
  origin: ~global.location.hostname.indexOf('local') ? 'localhost' : global.location.hostname,
  subscribeKey: '&',
  publishKey: '&'
  // subscribeKey: 'sub-c-03fd123c-a77f-11e7-a4bf-e61ccde79053',
  // publishKey: 'pub-c-f4ed425d-b6a6-4a47-8c64-c9037c3c87a4'
})

// Boot
App.boot({Vue, App, router, store, i18n, API, Charts})

// Version
global.version = version



// WEBPACK FOOTER //
// ./src/main.js